(ns ui.view.transaction-process.cards.card-header)

(defn view
  "Card header: the card label plus an optional subtitle. The bottom spacing
   that separates the header from the card body lives on the subtitle (`mb-4`)
   when there is one, otherwise it moves onto the title — so a subtitle-less card
   (e.g. a documents card) doesn't have its body butt up against the title."
  [{:keys [card]}]
  (let [subtitle (:card/subtitle card)]
    [:<>
     [:h3 {:class (str "text-base m-0 font-semibold text-gray-900 "
                       (if subtitle "mb-0.5" "mb-4"))}
      (:card/label card)]
     (when subtitle
       [:p {:class "text-sm m-0 text-gray-500 mb-4"} subtitle])]))
